export default __webpack_public_path__ + "static/media/JointerImg.009a6430.jpg";